import { caseStatusLabel, formatSlot, sessionStatusStyle } from "@/lib/caseLog";

const STYLE_BY_CASE = { in_progress: sessionStatusStyle.in_progress, resolved: sessionStatusStyle.completed, escalated: sessionStatusStyle.escalated };

function Line({ label, value }) {
  if (!value) return null;
  return <div><span className="text-slate-500">{label}:</span> <span className="text-slate-800 whitespace-pre-wrap">{value}</span></div>;
}

export default function CaseLogList({ logs }) {
  if (logs.length === 0) {
    return <div data-testid="caselog-list-empty" className="text-center py-10 text-slate-500">No case logs found.</div>;
  }
  return (
    <div className="space-y-3" data-testid="caselog-list">
      {logs.map((s) => {
        const log = s.case_log;
        const { date, slot } = formatSlot(s.scheduled_at);
        return (
          <div key={s.id} data-testid={`caselog-item-${s.id}`} className="border border-slate-200 rounded-xl p-4 bg-white">
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div>
                <div className="font-semibold text-slate-900">{s.user_name} · {s.category}</div>
                <div className="text-xs text-slate-500 mt-0.5">{date} · {slot} · Technician: <b>{log.technician_name || s.technician}</b></div>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-slate-600">{log.duration_minutes} min</span>
                <span data-testid={`caselog-status-${s.id}`} className={`text-xs font-bold uppercase tracking-wider px-2 py-0.5 rounded-md border ${STYLE_BY_CASE[log.status] || ""}`}>
                  {caseStatusLabel[log.status] || log.status}
                </span>
              </div>
            </div>
            <div className="text-sm mt-3 space-y-1">
              <Line label="Issue" value={log.issue_description} />
              <Line label="Steps taken" value={log.steps_taken} />
              <Line label="Resolution" value={log.resolution_notes} />
              <Line label="Customer satisfaction" value={log.customer_satisfaction} />
            </div>
            <div className="text-[11px] text-slate-400 mt-2">Updated {new Date(log.updated_at).toLocaleString("en-IN")}</div>
          </div>
        );
      })}
    </div>
  );
}
